import React, { useState, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import { useLazyQuery, useQuery } from "@apollo/client";

import SystemHeaderView from "../reuseableComponents/systemHeader/SystemHeaderView";
import WaterSystemSearch from "../reuseableComponents/WaterSystemSearch";
import ReportsMenu from "./ReportsMenu";
import InventoryReport from "./inventoryReport/InventoryReport";
import IpsReportHome from "./ips/ipsReport/IpsReportHome";
import SystemSummaryReport from "./systemSummaryReport/SystemSummaryReport";
import MonitoringScheduleReport from "./monitoringSchedules/MonitoringScheduleReport";
import BacterialSummaryReport from "./bacterialSummary/BacterialSummaryReport";
import SkeletonLoader from "../reuseableComponents/loaders/SkeletonLoader";
import { GET_SDWIS_REPORT_MENU } from "../../queries/menuQrys/baseWLMenuQrys";
import { GET_USER_SDWIS_REPORTS } from "../../queries/archiveQrys/secureQrys/userProfileQrys";
import { UserContext } from "../reuseableComponents/auth/UserContext";
import ErrorMessage from "../reuseableComponents/ErrorHandler";

const ReportsPage = (props) => {
  let { systemId } = useParams();
  let history = useHistory();
  const { user } = useContext(UserContext);
  const [sdwisReports, setSdwisReports] = useState([]);
  const [waterReport, setWaterReport] = useState({});

  const { loading, data, error } = useQuery(GET_SDWIS_REPORT_MENU, {
    onCompleted: (d) => {
      updateWaterReport(user);
    }
  });

  const [getSdwisReports] = useLazyQuery(GET_USER_SDWIS_REPORTS, {
    variables: { umdId: user.umdId },
    onCompleted: (d) => {
      setSdwisReports(d.getUserSdwisReportsByUmdId.tables);
      updateWaterReport(user);
    }
  });

  const updateWaterReport = (user) => {
    if (user.isStaff) {
      if (sdwisReports) {
        if (sdwisReports.length > 0) {
          setWaterReport({
            label: "My SDWIS Selections",
            value: "custom",
            access: "Staff"
          });
        } else {
          setWaterReport({
            label: "Inventory Report",
            value: "inventory",
            access: "Staff"
          });
        }
      } else {
        setWaterReport({
          label: "Inventory Report",
          value: "inventory",
          access: "Staff"
        });
      }
    }
    if (user.isPublic) {
      setWaterReport({
        label: "Water Monitoring Schedules",
        value: "monitoring",
        access: "Public"
      });
    }
  };

  const handleSearch = (value) => {
    history.push(`/reports/${value.value}`);

    //set report menu back to defaut public report
    //needed is a Portal user switches to a system they aren't attached to
    setWaterReport({
      label: "Water Monitoring Schedules",
      value: "monitoring",
      access: "Public"
    });
  };

  React.useEffect(() => {
    if (!user.isPublic) {
      getSdwisReports(user.umdId);
    }
    //The comment below MUST stay there so that react builds
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <SkeletonLoader width='100%' />;
  if (error) return <ErrorMessage error={error} />;

  return (
    <>
      <Row>
        <Col md={8}>
          <WaterSystemSearch handleSearch={handleSearch} autoFocus={false} />
        </Col>
        <Col>
          <ReportsMenu
            loading={loading}
            handleMenuChange={setWaterReport}
            defaultValue={waterReport}
            reportItems={data.getSdwisMenu}
            systemId={systemId}
            {...props}
          />
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col>
          <SystemHeaderView systemId={Number.parseInt(systemId)} />
        </Col>
      </Row>
      {waterReport.value === "inventory" ? (
        <InventoryReport {...props} />
      ) : waterReport.value === "ips" ? (
        <IpsReportHome {...props} />
      ) : waterReport.value === "monitoring" ? (
        <MonitoringScheduleReport {...props} />
      ) : waterReport.value === "systemSummary" ? (
        <SystemSummaryReport {...props} customSummary={false} />
      ) : waterReport.value === "custom" ? (
        <SystemSummaryReport {...props} customSummary={true} />
      ) : waterReport.value === "bacti" ? (
        <BacterialSummaryReport {...props} />
      ) : (
        ""
      )}
    </>
  );
};
export default ReportsPage;
